import React from 'react'

const Pytm4 = () => {
    return (
        <div className='container'>
        <h1>Reverse a Linked List in groups of given size</h1>
        <p>Given a linked list, write a function to reverse every k nodes (where k is an input to the function).&nbsp;</p>
        <p><strong>Example:</strong>&nbsp;</p>
        <blockquote><p><strong>Input</strong>: 1-&gt;2-&gt;3-&gt;4-&gt;5-&gt;6-&gt;7-&gt;8-&gt;NULL, K = 3&nbsp;<br/>
        <strong>Output</strong>: 3-&gt;2-&gt;1-&gt;6-&gt;5-&gt;4-&gt;8-&gt;7-&gt;NULL&nbsp;<br/>
        <strong>Input</strong>: 1-&gt;2-&gt;3-&gt;4-&gt;5-&gt;6-&gt;7-&gt;8-&gt;NULL, K = 5&nbsp;<br/>
        <strong>Output</strong>: 5-&gt;4-&gt;3-&gt;2-&gt;1-&gt;8-&gt;7-&gt;6-&gt;NULL&nbsp;</p></blockquote>
        <p><strong>Algorithm</strong>: <i>reverse</i><i>(head, k)</i>&nbsp;</p>
        <ul><li>Reverse the first sub-list of size k. While reversing keep track of the next node and previous node. Let the pointer to the next node be <i>next </i>and pointer to the previous node be <i>prev</i>.</li></ul>

        <div class="tabs">
<input type="radio" name="tab" id="tab1" />
<label for="tab1">CPP</label>
<input type="radio" name="tab" id="tab2"/>
<label for="tab2">C</label>
<input type="radio" name="tab" id="tab3"/>
<label for="tab3">Java</label>
<input type="radio" name="tab" id="tab4"/>
<label for="tab4">Python</label>

<div class="tab-content-wrapper">
  <div id="tab-content-1" class="tab-content">
  <div class="container">
<div class="line number1 index0 alt2"><code class="comment">// CPP program to reverse a linked list</code></div>
<div class="line number2 index1 alt1"><code class="comment">// in groups of given size</code></div>
<div class="line number3 index2 alt2"><code class="preprocessor">#include &lt;bits/stdc++.h&gt;</code></div>
<div class="line number4 index3 alt1"><code class="library">using</code> <code
        class="library">namespace</code> <code class="plain">std;</code></div>
<div class="line number5 index4 alt2">&nbsp;</div>
<div class="line number6 index5 alt1"><code class="comment">/* Link list node */</code></div>
<div class="line number7 index6 alt2"><code class="library">class</code> <code class="plain">Node &#123;</code>
</div>
<div class="line number8 index7 alt1"><code class="library">public</code><code class="plain">:</code></div>
<div class="line number9 index8 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1 bold">int</code> <code class="plain">data;</code></div>
<div class="line number10 index9 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">Node* next;</code></div>
<div class="line number11 index10 alt2"><code class="plain">&#125;;</code></div>
<div class="line number12 index11 alt1">&nbsp;</div>
<div class="line number13 index12 alt2"><code class="comment">/* Reverses the linked list in groups</code></div>
<div class="line number14 index13 alt1"><code class="comment">of size k and returns the pointer</code></div>
<div class="line number15 index14 alt2"><code class="comment">to the new head node. */</code></div>
<div class="line number16 index15 alt1"><code class="plain">Node* reverse(Node* head, </code><code
        class="color1 bold">int</code> <code class="plain">k)</code></div>
<div class="line number17 index16 alt2"><code class="plain">&#123;</code></div>
<div class="line number18 index17 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comment">// base case</code></div>
<div class="line number19 index18 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="library">if</code> <code class="plain">(!head)</code></div>
<div class="line number20 index19 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="library">return</code> <code class="plain">NULL;</code></div>
<div class="line number21 index20 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">Node* current = head;</code></div>
<div class="line number22 index21 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">Node* next = NULL;</code></div>
<div class="line number23 index22 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">Node* prev = NULL;</code></div>
<div class="line number24 index23 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1 bold">int</code> <code class="plain">count = 0;</code></div>
<div class="line number25 index24 alt2">&nbsp;</div>
<div class="line number26 index25 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comment">/*reverse first k nodes of the linked list */</code></div>
<div class="line number27 index26 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="library">while</code> <code class="plain">(current != NULL &amp;&amp; count &lt; k) &#123;</code>
</div>
<div class="line number28 index27 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">next = current-&gt;next;</code></div>
<div class="line number29 index28 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">current-&gt;next = prev;</code></div>
<div class="line number30 index29 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">prev = current;</code></div>
<div class="line number31 index30 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">current = next;</code></div>
<div class="line number32 index31 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">count++;</code></div>
<div class="line number33 index32 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number34 index33 alt1">&nbsp;</div>
<div class="line number35 index34 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comment">/* next is now a pointer to (k+1)th node</code></div>
<div class="line number36 index35 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comment">Recursively call for the list starting from current.</code></div>
<div class="line number37 index36 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comment">And make rest of the list as next of first node */</code></div>
<div class="line number38 index37 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="library">if</code> <code class="plain">(next != NULL)</code></div>
<div class="line number39 index38 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">head-&gt;next = reverse(next, k);</code></div>
<div class="line number40 index39 alt1">&nbsp;</div>
<div class="line number41 index40 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comment">/* prev is new head of the input list */</code></div>
<div class="line number42 index41 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="library">return</code> <code class="plain">prev;</code></div>
<div class="line number43 index42 alt2"><code class="plain">&#125;</code></div>
<div class="line number44 index43 alt1">&nbsp;</div>
<div class="line number45 index44 alt2"><code class="comment">/* UTILITY FUNCTIONS */</code></div>
<div class="line number46 index45 alt1"><code class="comment">/* Function to push a node */</code></div>
<div class="line number47 index46 alt2"><code class="library">void</code> <code
        class="plain">push(Node** head_ref, </code><code class="color1 bold">int</code> <code
        class="plain">new_data)</code></div>
<div class="line number48 index47 alt1"><code class="plain">&#123;</code></div>
<div class="line number49 index48 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comment">/* allocate node */</code></div>
<div class="line number50 index49 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">Node* new_node = </code><code class="library">new</code> <code
        class="plain">Node();</code></div>
<div class="line number51 index50 alt2">&nbsp;</div>
<div class="line number52 index51 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comment">/* put in the data */</code></div>
<div class="line number53 index52 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">new_node-&gt;data = new_data;</code></div>
<div class="line number54 index53 alt1">&nbsp;</div>
<div class="line number55 index54 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comment">/* link the old list off the new node */</code></div>
<div class="line number56 index55 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">new_node-&gt;next = (*head_ref);</code></div>
<div class="line number57 index56 alt2">&nbsp;</div>
<div class="line number58 index57 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comment">/* move the head to point to the new node */</code></div>
<div class="line number59 index58 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">(*head_ref) = new_node;</code></div>
<div class="line number60 index59 alt1"><code class="plain">&#125;</code></div>
<div class="line number61 index60 alt2">&nbsp;</div>
<div class="line number62 index61 alt1"><code class="comment">/* Function to print linked list */</code></div>
<div class="line number63 index62 alt2"><code class="library">void</code> <code
        class="plain">printList(Node* node)</code></div>
<div class="line number64 index63 alt1"><code class="plain">&#123;</code></div>
<div class="line number65 index64 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="library">while</code> <code class="plain">(node != NULL) &#123;</code></div>
<div class="line number66 index65 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">cout &lt;&lt; node-&gt;data &lt;&lt; </code><code class="string">" "</code><code
        class="plain">;</code></div>
<div class="line number67 index66 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">node = node-&gt;next;</code></div>
<div class="line number68 index67 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number69 index68 alt2"><code class="plain">&#125;</code></div>
<div class="line number70 index69 alt1">&nbsp;</div>
<div class="line number71 index70 alt2"><code class="comment">/* Driver code*/</code></div>
<div class="line number72 index71 alt1"><code class="color1 bold">int</code> <code class="plain">main()</code></div>
<div class="line number73 index72 alt2"><code class="plain">&#123;</code></div>
<div class="line number74 index73 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comment">/* Start with the empty list */</code></div>
<div class="line number75 index74 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">Node* head = NULL;</code></div>
<div class="line number76 index75 alt1">&nbsp;</div>
<div class="line number77 index76 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comment">/* Created Linked list</code></div>
<div class="line number78 index77 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comment">is 1-&gt;2-&gt;3-&gt;4-&gt;5-&gt;6-&gt;7-&gt;8-&gt;9 */</code></div>
<div class="line number79 index78 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">push(&amp;head, 9);</code></div>
<div class="line number80 index79 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">push(&amp;head, 8);</code></div>
<div class="line number81 index80 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">push(&amp;head, 7);</code></div>
<div class="line number82 index81 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">push(&amp;head, 6);</code></div>
<div class="line number83 index82 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">push(&amp;head, 5);</code></div>
<div class="line number84 index83 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">push(&amp;head, 4);</code></div>
<div class="line number85 index84 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">push(&amp;head, 3);</code></div>
<div class="line number86 index85 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">push(&amp;head, 2);</code></div>
<div class="line number87 index86 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">push(&amp;head, 1);</code></div>
<div class="line number88 index87 alt1">&nbsp;</div>
<div class="line number89 index88 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">cout &lt;&lt; </code><code class="string">"Given linked list \n"</code><code
        class="plain">;</code></div>
<div class="line number90 index89 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">printList(head);</code></div>
<div class="line number91 index90 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">head = reverse(head, 3);</code></div>
<div class="line number92 index91 alt1">&nbsp;</div>
<div class="line number93 index92 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">cout &lt;&lt; </code><code class="string">"\nReversed Linked list \n"</code><code
        class="plain">;</code></div>
<div class="line number94 index93 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">printList(head);</code></div>
<div class="line number95 index94 alt2">&nbsp;</div>
<div class="line number96 index95 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="library">return</code> <code class="plain">(0);</code></div>
<div class="line number97 index96 alt2"><code class="plain">&#125;</code></div>
<div class="line number98 index97 alt1">&nbsp;</div>

</div>
  </div>
  <div id="tab-content-2" class="tab-content">
  <div class="container">
<div class="line number1 index0 alt2"><code
        class="comments">// C program to reverse a linked list in groups of given size</code></div>
<div class="line number2 index1 alt1"><code class="preprocessor">#include&lt;stdio.h&gt;</code></div>
<div class="line number3 index2 alt2"><code class="preprocessor">#include&lt;stdlib.h&gt;</code></div>
<div class="line number4 index3 alt1">&nbsp;</div>
<div class="line number5 index4 alt2"><code class="comments">/* Link list node */</code></div>
<div class="line number6 index5 alt1"><code class="keyword bold">struct</code> <code class="plain">Node</code></div>
<div class="line number7 index6 alt2"><code class="plain">&#123;</code></div>
<div class="line number8 index7 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1 bold">int</code> <code class="plain">data;</code></div>
<div class="line number9 index8 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">struct</code> <code class="plain">Node* next;</code></div>
<div class="line number10 index9 alt1"><code class="plain">&#125;;</code></div>
<div class="line number11 index10 alt2">&nbsp;</div>
<div class="line number12 index11 alt1"><code
        class="comments">/* Reverses the linked list in groups of size k and returns the</code></div>
<div class="line number13 index12 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;</code><code
        class="comments">pointer to the new head node. */</code></div>
<div class="line number14 index13 alt1"><code class="keyword bold">struct</code> <code
        class="plain">Node *reverse (</code><code class="keyword bold">struct</code> <code
        class="plain">Node *head, </code><code class="color1 bold">int</code> <code class="plain">k)</code></div>
<div class="line number15 index14 alt2"><code class="plain">&#123;</code></div>
<div class="line number16 index15 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">if</code> <code class="plain">(!head)</code></div>
<div class="line number17 index16 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">NULL;</code></div>
<div class="line number18 index17 alt1"><code class="undefined spaces">&nbsp;&nbsp;</code>&nbsp;</div>
<div class="line number19 index18 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">struct</code> <code class="plain">Node* current = head;</code></div>
<div class="line number20 index19 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">struct</code> <code class="plain">Node* next = NULL;</code></div>
<div class="line number21 index20 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">struct</code> <code class="plain">Node* prev = NULL;</code></div>
<div class="line number22 index21 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1 bold">int</code> <code class="plain">count = 0;</code></div>
<div class="line number23 index22 alt2"><code class="undefined spaces">&nbsp;&nbsp;</code>&nbsp;</div>
<div class="line number24 index23 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
<div class="line number25 index24 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
<div class="line number26 index25 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/*reverse first k nodes of the linked list */</code></div>
<div class="line number27 index26 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">while</code> <code class="plain">(current != NULL &amp;&amp; count &lt; k)</code></div>
<div class="line number28 index27 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#123;</code></div>
<div class="line number29 index28 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">next&nbsp; = current-&gt;next;</code></div>
<div class="line number30 index29 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">current-&gt;next = prev;</code></div>
<div class="line number31 index30 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">prev = current;</code></div>
<div class="line number32 index31 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">current = next;</code></div>
<div class="line number33 index32 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">count++;</code></div>
<div class="line number34 index33 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number35 index34 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
<div class="line number36 index35 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* next is now a pointer to (k+1)th node</code></div>
<div class="line number37 index36 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">Recursively call for the list starting from current.</code></div>
<div class="line number38 index37 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">And make rest of the list as next of first node */</code></div>
<div class="line number39 index38 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">if</code> <code class="plain">(next !=&nbsp; NULL)</code></div>
<div class="line number40 index39 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">head-&gt;next = reverse(next, k);</code></div>
<div class="line number41 index40 alt2">&nbsp;</div>
<div class="line number42 index41 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* prev is new head of the input list */</code></div>
<div class="line number43 index42 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">prev;</code></div>
<div class="line number44 index43 alt1"><code class="plain">&#125;</code></div>
<div class="line number45 index44 alt2">&nbsp;</div>
<div class="line number46 index45 alt1"><code class="comments">/* UTILITY FUNCTIONS */</code></div>
<div class="line number47 index46 alt2"><code class="comments">/* Function to push a node */</code></div>
<div class="line number48 index47 alt1"><code class="keyword bold">void</code> <code class="plain">push(</code><code
        class="keyword bold">struct</code> <code class="plain">Node** head_ref, </code><code
        class="color1 bold">int</code> <code class="plain">new_data)</code></div>
<div class="line number49 index48 alt2"><code class="plain">&#123;</code></div>
<div class="line number50 index49 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* allocate node */</code></div>
<div class="line number51 index50 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">struct</code> <code class="plain">Node* new_node =</code></div>
<div class="line number52 index51 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">(</code><code class="keyword bold">struct</code> <code class="plain">Node*) </code><code
        class="functions bold">malloc</code><code class="plain">(</code><code
        class="keyword bold">sizeof</code><code class="plain">(</code><code class="keyword bold">struct</code> <code
        class="plain">Node));</code></div>
<div class="line number53 index52 alt2">&nbsp;</div>
<div class="line number54 index53 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* put in the data&nbsp; */</code></div>
<div class="line number55 index54 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">new_node-&gt;data&nbsp; = new_data;</code></div>
<div class="line number56 index55 alt1">&nbsp;</div>
<div class="line number57 index56 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* link the old list off the new node */</code></div>
<div class="line number58 index57 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">new_node-&gt;next = (*head_ref);&nbsp;&nbsp;&nbsp;</code></div>
<div class="line number59 index58 alt2">&nbsp;</div>
<div class="line number60 index59 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* move the head to point to the new node */</code></div>
<div class="line number61 index60 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">(*head_ref)&nbsp;&nbsp;&nbsp; = new_node;</code></div>
<div class="line number62 index61 alt1"><code class="plain">&#125;</code></div>
<div class="line number63 index62 alt2">&nbsp;</div>
<div class="line number64 index63 alt1"><code class="comments">/* Function to print linked list */</code></div>
<div class="line number65 index64 alt2"><code class="keyword bold">void</code> <code
        class="plain">printList(</code><code class="keyword bold">struct</code> <code
        class="plain">Node *node)</code></div>
<div class="line number66 index65 alt1"><code class="plain">&#123;</code></div>
<div class="line number67 index66 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">while</code> <code class="plain">(node != NULL)</code></div>
<div class="line number68 index67 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#123;</code></div>
<div class="line number69 index68 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="functions bold">printf</code><code class="plain">(</code><code class="string">"%d&nbsp; "</code><code
        class="plain">, node-&gt;data);</code></div>
<div class="line number70 index69 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">node = node-&gt;next;</code></div>
<div class="line number71 index70 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number72 index71 alt1"><code class="plain">&#125;&nbsp;&nbsp;&nbsp;</code></div>
<div class="line number73 index72 alt2">&nbsp;</div>
<div class="line number74 index73 alt1"><code class="comments">/* Driver code*/</code></div>
<div class="line number75 index74 alt2"><code class="color1 bold">int</code> <code class="plain">main(</code><code
        class="keyword bold">void</code><code class="plain">)</code></div>
<div class="line number76 index75 alt1"><code class="plain">&#123;</code></div>
<div class="line number77 index76 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* Start with the empty list */</code></div>
<div class="line number78 index77 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">struct</code> <code class="plain">Node* head = NULL;</code></div>
<div class="line number79 index78 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number80 index79 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* Created Linked list is 1-&gt;2-&gt;3-&gt;4-&gt;5-&gt;6-&gt;7-&gt;8-&gt;9 */</code></div>
<div class="line number81 index80 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">push(&amp;head, 9);</code></div>
<div class="line number82 index81 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">push(&amp;head, 8);</code></div>
<div class="line number83 index82 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">push(&amp;head, 7);</code></div>
<div class="line number84 index83 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">push(&amp;head, 6);</code></div>
<div class="line number85 index84 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">push(&amp;head, 5);</code></div>
<div class="line number86 index85 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">push(&amp;head, 4);</code></div>
<div class="line number87 index86 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">push(&amp;head, 3);</code></div>
<div class="line number88 index87 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">push(&amp;head, 2);</code></div>
<div class="line number89 index88 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">push(&amp;head, 1);&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code></div>
<div class="line number90 index89 alt1">&nbsp;</div>
<div class="line number91 index90 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="functions bold">printf</code><code class="plain">(</code><code
        class="string">"\nGiven linked list \n"</code><code class="plain">);</code></div>
<div class="line number92 index91 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">printList(head);</code></div>
<div class="line number93 index92 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">head = reverse(head, 3);</code></div>
<div class="line number94 index93 alt1">&nbsp;</div>
<div class="line number95 index94 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="functions bold">printf</code><code class="plain">(</code><code
        class="string">"\nReversed Linked list \n"</code><code class="plain">);</code></div>
<div class="line number96 index95 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">printList(head);</code></div>
<div class="line number97 index96 alt2">&nbsp;</div>
<div class="line number98 index97 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code><code class="plain">(0);</code></div>
<div class="line number99 index98 alt2"><code class="plain">&#125;</code></div>
</div>
 </div>
  <div id="tab-content-3" class="tab-content">
  <div class="container">
<div class="line number1 index0 alt2"><code
        class="comment">// Java program to reverse a linked list in groups of</code></div>
<div class="line number2 index1 alt1"><code class="comment">// given size</code></div>
<div class="line number3 index2 alt2"><code class="keywords">class</code> <code class="plain">LinkedList &#123;</code>
</div>
<div class="line number4 index3 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">Node head; </code><code class="comment">// head of list</code></div>
<div class="line number5 index4 alt2">&nbsp;</div>
<div class="line number6 index5 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comment">/* Linked list Node*/</code></div>
<div class="line number7 index6 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keywords">class</code> <code class="plain">Node &#123;</code></div>
<div class="line number8 index7 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keywords">int</code> <code class="plain">data;</code></div>
<div class="line number9 index8 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">Node next;</code></div>
<div class="line number10 index9 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">Node(</code><code class="keywords">int</code> <code class="plain">d)</code></div>
<div class="line number11 index10 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code>
</div>
<div class="line number12 index11 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">data = d;</code></div>
<div class="line number13 index12 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">next = </code><code class="keywords">null</code><code class="plain">;</code></div>
<div class="line number14 index13 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
</div>
<div class="line number15 index14 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number16 index15 alt1">&nbsp;</div>
<div class="line number17 index16 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">Node reverse(Node head, </code><code class="keywords">int</code> <code class="plain">k)</code>
</div>
<div class="line number18 index17 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#123;</code></div>
<div class="line number19 index18 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keywords">if</code><code class="plain">(head == </code><code class="keywords">null</code><code
        class="plain">)</code></div>
<div class="line number20 index19 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keywords">return</code> <code class="keywords">null</code><code class="plain">;</code></div>
<div class="line number21 index20 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">Node current = head;</code></div>
<div class="line number22 index21 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">Node next = </code><code class="keywords">null</code><code class="plain">;</code></div>
<div class="line number23 index22 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">Node prev = </code><code class="keywords">null</code><code class="plain">;</code></div>
<div class="line number24 index23 alt1">&nbsp;</div>
<div class="line number25 index24 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keywords">int</code> <code class="plain">count = </code><code class="value">0</code><code
        class="plain">;</code></div>
<div class="line number26 index25 alt1">&nbsp;</div>
<div class="line number27 index26 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comment">/* Reverse first k nodes of linked list */</code></div>
<div class="line number28 index27 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keywords">while</code> <code class="plain">(count &lt; k &amp;&amp; current != </code><code
        class="keywords">null</code><code class="plain">) &#123;</code></div>
<div class="line number29 index28 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">next = current.next;</code></div>
<div class="line number30 index29 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">current.next = prev;</code></div>
<div class="line number31 index30 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">prev = current;</code></div>
<div class="line number32 index31 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">current = next;</code></div>
<div class="line number33 index32 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">count++;</code></div>
<div class="line number34 index33 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
</div>
<div class="line number35 index34 alt2">&nbsp;</div>
<div class="line number36 index35 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comment">/* next is now a pointer to (k+1)th node</code></div>
<div class="line number37 index36 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comment">Recursively call for the list starting from</code></div>
<div class="line number38 index37 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comment">current. And make rest of the list as next of</code></div>
<div class="line number39 index38 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comment">first node */</code></div>
<div class="line number40 index39 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keywords">if</code> <code class="plain">(next != </code><code class="keywords">null</code><code
        class="plain">)</code></div>
<div class="line number41 index40 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">head.next = reverse(next, k);</code></div>
<div class="line number42 index41 alt1">&nbsp;</div>
<div class="line number43 index42 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comment">// prev is now head of input list</code></div>
<div class="line number44 index43 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keywords">return</code> <code class="plain">prev;</code></div>
<div class="line number45 index44 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number46 index45 alt1">&nbsp;</div>
<div class="line number47 index46 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comment">/* Utility functions */</code></div>
<div class="line number48 index47 alt1">&nbsp;</div>
<div class="line number49 index48 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comment">/* Inserts a new Node at front of the list. */</code></div>
<div class="line number50 index49 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keywords">public</code> <code class="keywords">void</code> <code class="plain">push(</code><code
        class="keywords">int</code> <code class="plain">new_data)</code></div>
<div class="line number51 index50 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#123;</code></div>
<div class="line number52 index51 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comment">/* 1 &amp; 2: Allocate the Node &amp;</code></div>
<div class="line number53 index52 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comment">Put in the data*/</code></div>
<div class="line number54 index53 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">Node new_node = </code><code class="keywords">new</code> <code
        class="plain">Node(new_data);</code></div>
<div class="line number55 index54 alt2">&nbsp;</div>
<div class="line number56 index55 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comment">/* 3. Make next of new Node as head */</code></div>
<div class="line number57 index56 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">new_node.next = head;</code></div>
<div class="line number58 index57 alt1">&nbsp;</div>
<div class="line number59 index58 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comment">/* 4. Move the head to point to new Node */</code></div>
<div class="line number60 index59 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">head = new_node;</code></div>
<div class="line number61 index60 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number62 index61 alt1">&nbsp;</div>
<div class="line number63 index62 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comment">/* Function to print linked list */</code></div>
<div class="line number64 index63 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keywords">void</code> <code class="plain">printList()</code></div>
<div class="line number65 index64 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#123;</code></div>
<div class="line number66 index65 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">Node temp = head;</code></div>
<div class="line number67 index66 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keywords">while</code> <code class="plain">(temp != </code><code class="keywords">null</code><code
        class="plain">) &#123;</code></div>
<div class="line number68 index67 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">System.out.print(temp.data + </code><code class="string">" "</code><code
        class="plain">);</code></div>
<div class="line number69 index68 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">temp = temp.next;</code></div>
<div class="line number70 index69 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
</div>
<div class="line number71 index70 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">System.out.println();</code></div>
<div class="line number72 index71 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number73 index72 alt2">&nbsp;</div>
<div class="line number74 index73 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comment">/* Driver program to test above functions */</code></div>
<div class="line number75 index74 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keywords">public</code> <code class="keywords">static</code> <code class="keywords">void</code> <code
        class="plain">main(String args[])</code></div>
<div class="line number76 index75 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#123;</code></div>
<div class="line number77 index76 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">LinkedList llist = </code><code class="keywords">new</code> <code
        class="plain">LinkedList();</code></div>
<div class="line number78 index77 alt1">&nbsp;</div>
<div class="line number79 index78 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comment">/* Constructed Linked List is 1-&gt;2-&gt;3-&gt;4-&gt;5-&gt;6-&gt;</code></div>
<div class="line number80 index79 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comment">7-&gt;8-&gt;8-&gt;9-&gt;null */</code></div>
<div class="line number81 index80 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">llist.push(</code><code class="value">9</code><code class="plain">);</code></div>
<div class="line number82 index81 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">llist.push(</code><code class="value">8</code><code class="plain">);</code></div>
<div class="line number83 index82 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">llist.push(</code><code class="value">7</code><code class="plain">);</code></div>
<div class="line number84 index83 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">llist.push(</code><code class="value">6</code><code class="plain">);</code></div>
<div class="line number85 index84 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">llist.push(</code><code class="value">5</code><code class="plain">);</code></div>
<div class="line number86 index85 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">llist.push(</code><code class="value">4</code><code class="plain">);</code></div>
<div class="line number87 index86 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">llist.push(</code><code class="value">3</code><code class="plain">);</code></div>
<div class="line number88 index87 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">llist.push(</code><code class="value">2</code><code class="plain">);</code></div>
<div class="line number89 index88 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">llist.push(</code><code class="value">1</code><code class="plain">);</code></div>
<div class="line number90 index89 alt1">&nbsp;</div>
<div class="line number91 index90 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">System.out.println(</code><code class="string">"Given Linked List"</code><code
        class="plain">);</code></div>
<div class="line number92 index91 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">llist.printList();</code></div>
<div class="line number93 index92 alt2">&nbsp;</div>
<div class="line number94 index93 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">llist.head = llist.reverse(llist.head, </code><code class="value">3</code><code
        class="plain">);</code></div>
<div class="line number95 index94 alt2">&nbsp;</div>
<div class="line number96 index95 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">System.out.println(</code><code class="string">"Reversed list"</code><code
        class="plain">);</code></div>
<div class="line number97 index96 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">llist.printList();</code></div>
<div class="line number98 index97 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number99 index98 alt2"><code class="plain">&#125;</code></div>

</div>
</div>
  <div id="tab-content-4" class="tab-content">
  <div class="container">
<div class="line number1 index0 alt2"><code class="comment"># Python program to reverse a</code></div>
<div class="line number2 index1 alt1"><code class="comment"># linked list in group of given size</code></div>
<div class="line number3 index2 alt2">&nbsp;</div>
<div class="line number4 index3 alt1"><code class="comment"># Node class</code></div>
<div class="line number5 index4 alt2">&nbsp;</div>
<div class="line number6 index5 alt1">&nbsp;</div>
<div class="line number7 index6 alt2"><code class="keywords">class</code> <code class="plain">Node:</code></div>
<div class="line number8 index7 alt1">&nbsp;</div>
<div class="line number9 index8 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comment"># Constructor to initialize the node object</code></div>
<div class="line number10 index9 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keywords">def</code> <code class="plain">__init__(</code><code class="color1">self</code><code
        class="plain">, data):</code></div>
<div class="line number11 index10 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1">self</code><code class="plain">.data </code><code class="keywords">=</code> <code
        class="plain">data</code></div>
<div class="line number12 index11 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1">self</code><code class="plain">.</code><code class="functions">next</code> <code
        class="keywords">=</code> <code class="color1">None</code></div>
<div class="line number13 index12 alt2">&nbsp;</div>
<div class="line number14 index13 alt1">&nbsp;</div>
<div class="line number15 index14 alt2"><code class="keywords">class</code> <code class="plain">LinkedList:</code>
</div>
<div class="line number16 index15 alt1">&nbsp;</div>
<div class="line number17 index16 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comment"># Function to initialize head</code></div>
<div class="line number18 index17 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keywords">def</code> <code class="plain">__init__(</code><code class="color1">self</code><code
        class="plain">):</code></div>
<div class="line number19 index18 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1">self</code><code class="plain">.head </code><code class="keywords">=</code> <code
        class="color1">None</code></div>
<div class="line number20 index19 alt1">&nbsp;</div>
<div class="line number21 index20 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keywords">def</code> <code class="plain">reverse(</code><code class="color1">self</code><code
        class="plain">, head, k):</code></div>
<div class="line number22 index21 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
<div class="line number23 index22 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keywords">if</code> <code class="plain">head </code><code class="keywords">=</code><code
        class="keywords">=</code> <code class="color1">None</code><code class="plain">:</code></div>
<div class="line number24 index23 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keywords">return</code> <code class="color1">None</code></div>
<div class="line number25 index24 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">current </code><code class="keywords">=</code> <code class="plain">head</code></div>
<div class="line number26 index25 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="functions">next</code> <code class="keywords">=</code> <code class="color1">None</code></div>
<div class="line number27 index26 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">prev </code><code class="keywords">=</code> <code class="color1">None</code></div>
<div class="line number28 index27 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">count </code><code class="keywords">=</code> <code class="value">0</code></div>
<div class="line number29 index28 alt2">&nbsp;</div>
<div class="line number30 index29 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comment"># Reverse first k nodes of the linked list</code></div>
<div class="line number31 index30 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keywords">while</code><code class="plain">(current </code><code class="keywords">is</code> <code
        class="keywords">not</code> <code class="color1">None</code> <code class="keywords">and</code> <code
        class="plain">count &lt; k):</code></div>
<div class="line number32 index31 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="functions">next</code> <code class="keywords">=</code> <code class="plain">current.</code><code
        class="functions">next</code></div>
<div class="line number33 index32 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">current.</code><code class="functions">next</code> <code class="keywords">=</code> <code
        class="plain">prev</code></div>
<div class="line number34 index33 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">prev </code><code class="keywords">=</code> <code class="plain">current</code></div>
<div class="line number35 index34 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">current </code><code class="keywords">=</code> <code class="functions">next</code></div>
<div class="line number36 index35 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">count </code><code class="keywords">+</code><code class="keywords">=</code> <code
        class="value">1</code></div>
<div class="line number37 index36 alt2">&nbsp;</div>
<div class="line number38 index37 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comment"># next is now a pointer to (k+1)th node</code></div>
<div class="line number39 index38 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comment"># recursively call for the list starting</code></div>
<div class="line number40 index39 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comment"># from current. And make rest of the list as</code></div>
<div class="line number41 index40 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comment"># next of first node</code></div>
<div class="line number42 index41 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keywords">if</code> <code class="functions">next</code> <code class="keywords">is</code> <code
        class="keywords">not</code> <code class="color1">None</code><code class="plain">:</code></div>
<div class="line number43 index42 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">head.</code><code class="functions">next</code> <code class="keywords">=</code> <code
        class="color1">self</code><code class="plain">.reverse(</code><code class="functions">next</code><code
        class="plain">, k)</code></div>
<div class="line number44 index43 alt1">&nbsp;</div>
<div class="line number45 index44 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comment"># prev is new head of the input list</code></div>
<div class="line number46 index45 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keywords">return</code> <code class="plain">prev</code></div>
<div class="line number47 index46 alt2">&nbsp;</div>
<div class="line number48 index47 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comment"># Function to insert a new node at the beginning</code></div>
<div class="line number49 index48 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keywords">def</code> <code class="plain">push(</code><code class="color1">self</code><code
        class="plain">, new_data):</code></div>
<div class="line number50 index49 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">new_node </code><code class="keywords">=</code> <code class="plain">Node(new_data)</code></div>
<div class="line number51 index50 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">new_node.</code><code class="functions">next</code> <code class="keywords">=</code> <code
        class="color1">self</code><code class="plain">.head</code></div>
<div class="line number52 index51 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1">self</code><code class="plain">.head </code><code class="keywords">=</code> <code
        class="plain">new_node</code></div>
<div class="line number53 index52 alt2">&nbsp;</div>
<div class="line number54 index53 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comment"># Utility function to print the linked LinkedList</code></div>
<div class="line number55 index54 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keywords">def</code> <code class="plain">printList(</code><code class="color1">self</code><code
        class="plain">):</code></div>
<div class="line number56 index55 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">temp </code><code class="keywords">=</code> <code class="color1">self</code><code
        class="plain">.head</code></div>
<div class="line number57 index56 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keywords">while</code><code class="plain">(temp):</code></div>
<div class="line number58 index57 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="functions">print</code> <code class="plain">temp.data,</code></div>
<div class="line number59 index58 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">temp </code><code class="keywords">=</code> <code class="plain">temp.</code><code
        class="functions">next</code></div>
<div class="line number60 index59 alt1">&nbsp;</div>
<div class="line number61 index60 alt2">&nbsp;</div>
<div class="line number62 index61 alt1"><code class="comment"># Driver program</code></div>
<div class="line number63 index62 alt2"><code class="plain">llist </code><code class="keywords">=</code> <code
        class="plain">LinkedList()</code></div>
<div class="line number64 index63 alt1"><code class="plain">llist.push(</code><code class="value">9</code><code
        class="plain">)</code></div>
<div class="line number65 index64 alt2"><code class="plain">llist.push(</code><code class="value">8</code><code
        class="plain">)</code></div>
<div class="line number66 index65 alt1"><code class="plain">llist.push(</code><code class="value">7</code><code
        class="plain">)</code></div>
<div class="line number67 index66 alt2"><code class="plain">llist.push(</code><code class="value">6</code><code
        class="plain">)</code></div>
<div class="line number68 index67 alt1"><code class="plain">llist.push(</code><code class="value">5</code><code
        class="plain">)</code></div>
<div class="line number69 index68 alt2"><code class="plain">llist.push(</code><code class="value">4</code><code
        class="plain">)</code></div>
<div class="line number70 index69 alt1"><code class="plain">llist.push(</code><code class="value">3</code><code
        class="plain">)</code></div>
<div class="line number71 index70 alt2"><code class="plain">llist.push(</code><code class="value">2</code><code
        class="plain">)</code></div>
<div class="line number72 index71 alt1"><code class="plain">llist.push(</code><code class="value">1</code><code
        class="plain">)</code></div>
<div class="line number73 index72 alt2">&nbsp;</div>
<div class="line number74 index73 alt1"><code class="keywords">print</code> <code
        class="string">"Given linked list"</code></div>
<div class="line number75 index74 alt2"><code class="plain">llist.printList()</code></div>
<div class="line number76 index75 alt1"><code class="plain">llist.head </code><code class="keywords">=</code> <code
        class="plain">llist.reverse(llist.head, </code><code class="value">3</code><code class="plain">)</code>
</div>
<div class="line number77 index76 alt2">&nbsp;</div>
<div class="line number78 index77 alt1"><code class="keywords">print</code> <code
        class="string">"\nReversed Linked list"</code></div>
<div class="line number79 index78 alt2"><code class="plain">llist.printList()</code></div>
<div class="line number80 index79 alt1">&nbsp;</div>
</div>
    </div>
</div>
</div>

    </div>
    )
}

export default Pytm4
